import React, { useEffect, useRef, useState } from "react";
import { getAnimalByIdE } from "../../api/animalsApi";
import QRCode from "react-qr-code";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import "../admin/details.css";
import { useTranslation } from "react-i18next";
import { GiCow } from "react-icons/gi";
import { FiHash, FiTag, FiCalendar, FiUser } from "react-icons/fi";
import { TbWeight, TbGenderBigender } from "react-icons/tb";
import { MdPets } from "react-icons/md";

export const DetailsAnimalE = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const [numero, setNumero] = useState('');
    const [nom, setNom] = useState('');
    const [dateNaissance, setDateNaissance] = useState('');
    const [poids, setPoids] = useState('');
    const [genre, setGenre] = useState('');
    const [phase, setPhase] = useState('');
    const [race, setRace] = useState('');
    const [user, setUser] = useState('');
    const [statuss, setStatus] = useState('');

    useEffect(() => {
        getAnimalByIdE(id).then(data => {
            setNumero(data.numero ?? '');
            setNom(data.nom ?? '');
            setDateNaissance(data.date_naissance ?? '');
            setPoids(data.poids ?? '');
            setGenre(data.genre ?? '');
            setPhase(data.phase?.titre ?? '');
            setRace(data.race?.nom ?? '');
            setUser(data.user?.nom ?? '');
            setStatus(data.reproductions?.[0]?.status?.titre ?? '');
        });
    }, [id]);

    const qrRef = useRef();
    const qrValue =
        t("animalDetails.fields.number") + ': ' + numero +
        '\n' + t("animalDetails.fields.name") + ': ' + nom +
        '\n' + t("animalDetails.fields.gender") + ': ' + genre +
        '\n' + t("animalDetails.fields.race") + ': ' + race +
        '\n' + t("animalDetails.fields.phase") + ': ' + phase +
        '\n' + t("animalDetails.fields.birthDate") + ': ' + dateNaissance +
        '\n' + t("animalDetails.fields.assignedUser") + ': ' + user +
        '\n' + t("animalDetails.fields.status") + ': ' + statuss;

    const handlePrint = useReactToPrint({
        contentRef: qrRef,
        documentTitle: `${t("animalDetails.documentTitlePrefix")} ${numero} - ${nom}`,
    });

    return (
        <div className="details-wrapper">
            <div className="details-shell">
                <section className="details-hero">
                    <div className="details-hero-copy">
                        <div className="details-kicker">{t("animalDetails.kicker")}</div>
                        <div className="details-header">
                            <div className="details-avatar">
                                <GiCow />
                            </div>
                            <div className="details-header-text">
                                <h1 className="details-title">{nom || t("animalDetails.fallbackAnimal")}</h1>
                                <p className="details-subtitle">
                                    {numero && <span>#{numero}</span>}
                                    {race && <span> · {race}</span>}
                                    {phase && <span> · {phase}</span>}
                                </p>
                            </div>
                            {statuss && (
                                <span className="details-status-badge">{statuss}</span>
                            )}
                        </div>
                    </div>

                    <div className="details-metrics" aria-label={t("animalDetails.summaryAriaLabel")}>
                        <div className="details-metric">
                            <span className="details-metric-label">{t("animalDetails.fields.gender")}</span>
                            <strong className="details-metric-value">{genre || t("animalDetails.empty")}</strong>
                        </div>
                        <div className="details-metric">
                            <span className="details-metric-label">{t("animalDetails.fields.weight")}</span>
                            <strong className="details-metric-value">{poids ? `${poids} ${t("animalDetails.kg")}` : t("animalDetails.empty")}</strong>
                        </div>
                        <div className="details-metric">
                            <span className="details-metric-label">{t("animalDetails.fields.assignedUser")}</span>
                            <strong className="details-metric-value">{user || t("animalDetails.empty")}</strong>
                        </div>
                    </div>
                </section>

                <div className="details-layout">
                    <section className="details-stream" aria-label={t("animalDetails.detailsAriaLabel")}>
                        <div className="details-stream-head">
                            <span className="details-stream-title">{t("animalDetails.streamTitle")}</span>
                            <span className="details-stream-line" />
                        </div>

                        <div className="details-grid">
                            <div className="details-item">
                                <div className="details-item-label">
                                    <FiHash />
                                    <span>{t("animalDetails.fields.number")}</span>
                                </div>
                                <div className="details-item-value">{numero || t("animalDetails.empty")}</div>
                            </div>
                            <div className="details-item">
                                <div className="details-item-label">
                                    <FiTag />
                                    <span>{t("animalDetails.fields.name")}</span>
                                </div>
                                <div className="details-item-value">{nom || t("animalDetails.empty")}</div>
                            </div>
                            <div className="details-item">
                                <div className="details-item-label">
                                    <FiCalendar />
                                    <span>{t("animalDetails.fields.birthDate")}</span>
                                </div>
                                <div className="details-item-value">{dateNaissance || t("animalDetails.empty")}</div>
                            </div>
                            <div className="details-item">
                                <div className="details-item-label">
                                    <TbWeight />
                                    <span>{t("animalDetails.fields.weight")}</span>
                                </div>
                                <div className="details-item-value">{poids ? `${poids} ${t("animalDetails.kg")}` : t("animalDetails.empty")}</div>
                            </div>
                            <div className="details-item">
                                <div className="details-item-label">
                                    <TbGenderBigender />
                                    <span>{t("animalDetails.fields.gender")}</span>
                                </div>
                                <div className="details-item-value">{genre || t("animalDetails.empty")}</div>
                            </div>
                            <div className="details-item">
                                <div className="details-item-label">
                                    <FiCalendar />
                                    <span>{t("animalDetails.fields.phase")}</span>
                                </div>
                                <div className="details-item-value">{phase || t("animalDetails.empty")}</div>
                            </div>
                            <div className="details-item">
                                <div className="details-item-label">
                                    <MdPets />
                                    <span>{t("animalDetails.fields.race")}</span>
                                </div>
                                <div className="details-item-value">{race || t("animalDetails.empty")}</div>
                            </div>
                            <div className="details-item">
                                <div className="details-item-label">
                                    <FiUser />
                                    <span>{t("animalDetails.fields.assignedUser")}</span>
                                </div>
                                <div className="details-item-value">{user || t("animalDetails.empty")}</div>
                            </div>
                        </div>
                    </section>

                    <aside className="details-qr-panel">
                        <div ref={qrRef} className="qr-print-area">
                            <div className="details-kicker details-kicker-qr">{t("animalDetails.qrKicker")}</div>
                            <h2>{t("animalDetails.qrTitle")}</h2>
                            <div className="details-qr-frame">
                                <QRCode value={qrValue} size={170} />
                            </div>
                            <p className="details-qr-caption">{t("animalDetails.qrCaption")}</p>
                        </div>
                        <button onClick={handlePrint} className="print-btn" disabled={!qrRef.current}>
                            {t("animalDetails.printQr")}
                        </button>
                    </aside>
                </div>
            </div>
        </div>
    );
};